import { useMemo } from 'react';
import { Node } from '../../Tree';
import { FormGroup } from '../model/FormGroup';
import { Group } from '../model/Group';

function instanceOfGroup(elem: Group | FormGroup): elem is Group {
  return 'children' in elem;
}

export const useGetCustomTreeNodesAndForms = (groups: Array<Group>) => {
  return useMemo(() => {
    const nodes: Array<Node> = [];
    const forms: Map<Node, FormGroup['form']> = new Map();
    const branches: Array<Node> = [];

    function visitGroup(group: Group, parentNode: Node) {
      group.children.forEach((childGroup, i) => {
        const childNode = {
          id: `${parentNode.id}-Child-${i}`,
          text: childGroup.name,
          children: [],
        };
        parentNode.children?.push(childNode);

        if (instanceOfGroup(childGroup)) {
          branches.push(childNode);
          visitGroup(childGroup, childNode);
        } else {
          forms.set(childNode, childGroup.form);
        }
      });
    }

    groups.forEach((group, i) => {
      const node: Node = { id: `Custom-${i}`, text: group.name, children: [] };
      nodes.push(node);
      branches.push(node);
      visitGroup(group, node);
    });

    return { nodes, forms, branches };
  }, [groups]);
};
